import { z } from "zod";

export const contactOriginSchema = z.enum([
  "directory_import",
  "spreadsheet_import",
  "manual_research",
  "field_discovery",
  "email_sync",
  "other",
]);
export type ContactOrigin = z.infer<typeof contactOriginSchema>;

export const contactVerificationSchema = z.enum(["unverified", "verified"]);
export type ContactVerification = z.infer<typeof contactVerificationSchema>;

export const labContactRoleSchema = z.enum([
  "lab_manager",
  "calibration_coordinator",
  "purchasing",
  "quality",
  "principal_investigator",
  "decision_maker",
  "other",
]);
export type LabContactRole = z.infer<typeof labContactRoleSchema>;

export const labContactRelationshipStatusSchema = z.enum([
  "possible",
  "confirmed",
  "former",
]);
export type LabContactRelationshipStatus = z.infer<
  typeof labContactRelationshipStatusSchema
>;

export const influenceScopeSchema = z.enum([
  "lab",
  "department",
  "building",
  "campus",
  "institution",
]);
export type InfluenceScope = z.infer<typeof influenceScopeSchema>;

export const contactOriginLabels: Record<ContactOrigin, string> = {
  directory_import: "Directory import",
  spreadsheet_import: "Spreadsheet import",
  manual_research: "Manual research",
  field_discovery: "Field discovery",
  email_sync: "Email sync",
  other: "Other",
};

export const contactVerificationLabels: Record<ContactVerification, string> = {
  unverified: "Unverified",
  verified: "Verified",
};

export const labContactRoleLabels: Record<LabContactRole, string> = {
  lab_manager: "Lab manager",
  calibration_coordinator: "Calibration coordinator",
  purchasing: "Purchasing",
  quality: "Quality",
  principal_investigator: "Principal investigator",
  decision_maker: "Decision-maker",
  other: "Other",
};

export const labContactRelationshipStatusLabels: Record<
  LabContactRelationshipStatus,
  string
> = {
  possible: "Possible",
  confirmed: "Confirmed",
  former: "Former",
};

export const influenceScopeLabels: Record<InfluenceScope, string> = {
  lab: "Lab",
  department: "Department",
  building: "Building",
  campus: "Campus",
  institution: "Institution",
};
